import { render, staticRenderFns } from "./instances.vue?vue&type=template&id=740dd134&"
import script from "./instances.vue?vue&type=script&lang=js&"
export * from "./instances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports